export default __webpack_public_path__ + "static/media/restaurant-7-rMIN.4a44ee31.jpg";